import { Box, FormControlLabel, Radio, RadioGroup } from "@mui/material";

const OrderByOptions = ({
  options,
  selectedOption,
  setSelectedOption,
}: {
  options: string[];
  selectedOption: string;
  setSelectedOption: React.Dispatch<React.SetStateAction<string>>;
}) => {
  const handleSelect = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSelectedOption(event.target.value);
  };
  return (
    <Box>
      <RadioGroup value={selectedOption} onChange={handleSelect}>
        {options.map((option) => (
          <FormControlLabel
            key={option}
            value={option}
            control={
              <Radio
                sx={{
                  color: "#d9d9d9",
                  "&.Mui-checked": {
                    color: "black",
                  },
                }}
              />
            }
            label={option}
          />
        ))}
      </RadioGroup>
    </Box>
  );
};

export default OrderByOptions;
